import { render } from "./GenInput.vue?vue&type=template&id=48077a36"
import script from "./GenInput.vue?vue&type=script&lang=js"
export * from "./GenInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__